import { AutoMap } from '@automapper/classes';

export class OperatorEntity {
    Id?: number;
    @AutoMap()
    Position!: number;
    @AutoMap()
    FirstName!: string;
    @AutoMap()
    LastName!: string;
    TaskIds?: number[];
    CassetteIds?: number[];
}
